import { useState } from 'react';
import { supabase } from '../supabaseClient';

const LS_KEY = 'cde_lgpd_aceito';

// Verifica rapidamente via localStorage (evita piscar o banner em cargas subsequentes)
export function lgpdJaAceito() {
  try {
    return localStorage.getItem(LS_KEY) === '1';
  } catch (_) {
    return false;
  }
}

export default function LGPDConsent({ userId, onAceitar, onVerPolitica }) {
  const [loading, setLoading] = useState(false);

  const handleAceitar = async () => {
    setLoading(true);
    try {
      await supabase
        .from('profiles')
        .update({ lgpd_consent_at: new Date().toISOString() })
        .eq('id', userId);
    } catch (_) {
      // não bloqueia — localStorage garante que não reapareça
    }
    try { localStorage.setItem(LS_KEY, '1'); } catch (_) {}
    setLoading(false);
    onAceitar();
  };

  return (
    <div className="lgpd-overlay">
      <div className="lgpd-sheet">
        {/* Logo / marca */}
        <div className="lgpd-logo">
          <span className="lgpd-logo-text">Clube do Eu</span>
        </div>

        <h2 className="lgpd-titulo">Antes de continuar</h2>

        <p className="lgpd-corpo">
          Para oferecer a melhor experiência, coletamos e armazenamos seus
          dados de uso — como humor diário, reflexões e progresso.
        </p>

        <p className="lgpd-corpo">
          Seus dados são protegidos conforme a{' '}
          <strong>Lei Geral de Proteção de Dados (LGPD)</strong> e nunca são
          vendidos a terceiros.
        </p>

        <button
          type="button"
          className="lgpd-link"
          onClick={onVerPolitica}
        >
          Ler a Política de Privacidade completa →
        </button>

        <button
          className="btn btn-primary lgpd-btn-aceitar"
          onClick={handleAceitar}
          disabled={loading}
        >
          {loading ? 'Registrando...' : 'Li e concordo'}
        </button>

        <p className="lgpd-rodape">
          Ao continuar, você confirma que leu e concorda com a coleta e uso
          dos seus dados conforme descrito na nossa Política de Privacidade.
        </p>
      </div>
    </div>
  );
}
